import classes from './Inputs.module.css';
import { Textarea, TextareaProps } from '@mantine/core';
import { useResizeObserver } from '@mantine/hooks';
import { useCapabilityHelpLabel } from '@/pages/Editor/components/StepSidebar/CapabilityHelpContext.tsx';

type StyledTextareaProps = TextareaProps & { capabilityFieldId?: string };

const StyledTextArea = ({ capabilityFieldId, ...props }: StyledTextareaProps) => {
  const label = useCapabilityHelpLabel(props.label, capabilityFieldId);
  // for some reason, wrapping the text area in a div with a resize observer fixes the resizing issue
  const [containerRef] = useResizeObserver();

  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      <Textarea
        {...props}
        label={label}
        classNames={{
          input: classes.input,
          label: classes.label,
        }}
      />
    </div>
  );
};

export default StyledTextArea;
